import { getAttributionCookie } from "@/shared/lib/attribution-cookie";
import { ANALYTICS_PROVIDER } from "../models";
import type {
  GoogleTagManagerEventDetails,
  GoogleTagManagerPurchaseDetails,
  GoogleTagManagerUserData,
  PrefixedGoogleTagManagerEvent,
} from "../models";
import { handleAnalyticsError } from "../utils";

const FUNNEL_ID = "funnel_2nFHRnZBxP";
const FUNNEL_NAME = "LevelsRx - App funnel";

interface GoogleTagManagerTrackingParams<
  T extends GoogleTagManagerEventDetails | GoogleTagManagerPurchaseDetails,
> {
  event: PrefixedGoogleTagManagerEvent;
  user_data?: GoogleTagManagerUserData;
  ecommerce?: T;
}

export const initGoogleTagManagerTracking = () => {
  try {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  } catch (error) {
    handleAnalyticsError(error, {
      message: "Error initializing GoogleTagManager",
      provider: ANALYTICS_PROVIDER.GOOGLE_TAG_MANAGER,
    });
  }
};

export const triggerGoogleTagManagerTracking = <
  T extends GoogleTagManagerEventDetails | GoogleTagManagerPurchaseDetails,
>({
  event,
  user_data,
  ecommerce,
}: GoogleTagManagerTrackingParams<T>) => {
  try {
    if (!window.dataLayer) {
      throw new Error("GoogleTagManager not initialized");
    }

    const affid = getAttributionCookie()?.affid;

    window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce object
    window.dataLayer.push({
      event,
      funnel_id: FUNNEL_ID,
      funnel_name: FUNNEL_NAME,
      affiliate_id: affid,
      user_data,
      ecommerce,
    });
  } catch (error) {
    handleAnalyticsError(error, {
      message: "Error tracking GoogleTagManager event",
      provider: ANALYTICS_PROVIDER.GOOGLE_TAG_MANAGER,
      extra: {
        event,
        user_data,
        ecommerce,
      },
    });
  }
};
